import script from "./settings-default-agent-license-value.vue?vue&type=script&lang=ts&setup=true"
export * from "./settings-default-agent-license-value.vue?vue&type=script&lang=ts&setup=true"

import "./settings-default-agent-license-value.vue?vue&type=style&index=0&id=cfcd809c&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfcd809c"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField});
